import { useMemo } from 'react';

import type { SignPetitionHookInput } from '#src/app/shared/hooks/signature';

import { usePromotedTrackingDataWithQueryParams } from '../../usePromotedTrackingDataWithQueryParams';

type Result = Pick<SignPetitionHookInput, 'promotionToken' | 'promotionPlacement'>;

export function usePromotionSignData(): Result {
	const promotedData = usePromotedTrackingDataWithQueryParams();

	return useMemo(
		() => ({
			promotionToken: promotedData?.token || null,
			promotionPlacement: promotedData?.placement || null,
			promotionAlgorithm: promotedData?.algorithm || null,
		}),
		[promotedData],
	);
}
